export default __webpack_public_path__ + "static/media/spreads@2x.f6b1acb7.svg";